import { likeCarSuccess } from '../actions/car.actions';
import { likeRealEstateSuccess } from '../actions/real-estate.actions';
// store/reducers/users.reducer.ts
import { createReducer, on } from '@ngrx/store';
import {
  changeUserPage,
  changeUserPageSize,
  changeUserSort,
  clearUser,
  clearUsers,
  deleteUser,
  deleteUserSuccess,
  getUserFailure,
  getUserSuccess,
  loadUsers,
  loadUsersFailure,
  loadUsersSuccess,
  setUserMapView,
  toggleUserMapView,
  updateUser,
  updateUserSuccess,
} from '../actions/users.action';
import { initialUSerState } from '../states/users.state';

export const usersReducer = createReducer(
  initialUSerState,
  on(likeCarSuccess, (state, { car, userId }) => {
    const user = state.user;
    if (!user) return state;
    const items = user.likedCars ?? [];
    const updated = items.map(item => item.id === car.id ? { ...item, ...car } : item);
    return { ...state, user: { ...user,
      cars: user.cars?.map(item => item.id === car.id ? { ...item, ...car } : item),
      // Membership belongs to the acting user's Favorites; other profiles keep their collections.
      likedCars: user.id !== userId ? updated : car.liked
        ? items.some(item => item.id === car.id) ? updated : [...items, car]
        : items.filter(item => item.id !== car.id),
    } };
  }),
  on(likeRealEstateSuccess, (state, { realEstate, userId }) => {
    const user = state.user;
    if (!user) return state;
    const items = user.likedRealEstates ?? [];
    const updated = items.map(item => item.id === realEstate.id ? { ...item, ...realEstate } : item);
    return { ...state, user: { ...user,
      realEstates: user.realEstates?.map(item => item.id === realEstate.id ? { ...item, ...realEstate } : item),
      // Membership belongs to the acting user's Favorites; other profiles keep their collections.
      likedRealEstates: user.id !== userId ? updated : realEstate.liked
        ? items.some(item => item.id === realEstate.id) ? updated : [...items, realEstate]
        : items.filter(item => item.id !== realEstate.id),
    } };
  }),
  on(loadUsers, (state, { query }) => ({ ...state, query, loading: true, error: null, pagination: { ...state.pagination, pageIndex: 0 } })),
  on(loadUsersSuccess, (state, { users }) => ({
    ...state,
    loading: false,
    users,
  })),
  on(loadUsersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(getUserSuccess, (state, { user }) => ({
    ...state,
    loading: false,
    user: user,
  })),
  on(getUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(updateUser, (state) => ({
    ...state,
    isSaving: true,
    savingError: null,
  })),
  on(updateUserSuccess, (state, { user }) => ({
    ...state,
    isSaving: false,
    users: state.users?.map((u) => (u.id === user.id ? user : u)),
    user: state.user?.id === user.id ? user : state.user,
  })),
  on(deleteUser, (state) => ({
    ...state,
    isSaving: true,
    savingError: null,
  })),
  on(deleteUserSuccess, (state, { id }) => ({
    ...state,
    isSaving: false,
    users: state.users?.filter((u) => u.id !== id),
    user: state.user?.id === id ? undefined : state.user,
  })),
  on(clearUsers, (state) => ({
    ...state,
    query: undefined,
    users: undefined,
    loading: false,
    error: null,
    pagination: { ...state.pagination, pageIndex: 0 },
  })),
  on(clearUser, (state) => ({
    ...state,
    user: undefined,
  })),
  on(changeUserSort, (state, { active, direction }) => ({
    ...state,
    sort: { active, direction },
    pagination: {
      ...state.pagination,
      pageIndex: 0, // reset on sort change
    },
  })),

  on(changeUserPage, (state, { pageIndex }) => ({
    ...state,
    pagination: {
      ...state.pagination,
      pageIndex,
    },
  })),

  on(changeUserPageSize, (state, { pageSize }) => ({
    ...state,
    pagination: {
      pageSize,
      pageIndex: 0,
    },
  })),

  on(setUserMapView, (state, { isUserMapView: isMapView }) => ({
    ...state,
    isUserMapView: isMapView,
  })),

  on(toggleUserMapView, (state) => ({
    ...state,
    isUserMapView: !state.isUserMapView,
  }))
);
